<template>
  <div class="addOrUpdateRunCommands">
    <div class="addOrUpdateRunCommands-title">
      <Breadcrumb>
        <BreadcrumbItem to="/patchManagement/policies">{{
          $t("PatchEasy.PatchPolicy.title")
        }}</BreadcrumbItem>
        <BreadcrumbItem>{{
          $t("PatchEasy.PatchPolicy.patchcmdPara")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Form ref="commandForm" :model="commandForm" :label-width="100">
      <!-- 命令参数 -->
      <Row style="margin-bottom: 20px;">
        <Col span="24">
          <Card>
            <Row>
              <Col span="24" class="title"
                >{{
                  $t("patch_management.patch_policy.CommandParameters")
                }}:</Col
              >
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.Operating")
              }}</Col>
              <Col span="24">
                <Select
                  v-model="commandForm.operation"
                  style="width:70%;"
                  :transfer="true"
                  placeholder=""
                >
                  <Option
                    :value="item.id"
                    v-for="item in operationList"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.SnapshotId")
              }}</Col>
              <Col span="24">
                <Input
                  type="text"
                  v-model="commandForm.snapshotId"
                  style="width:70%;"
                ></Input>
              </Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.InstallationCoverageList")
              }}</Col>
              <Col span="24">
                <Input
                  type="text"
                  v-model="commandForm.installOverrideList"
                  style="width:70%;"
                ></Input>
              </Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.WhetherToBackup")
              }}</Col>
              <Col span="24">
                <RadioGroup v-model="commandForm.isBackup">
                  <Radio label="0">{{
                    $t("patch_management.patch_policy.yes")
                  }}</Radio>
                  <Radio label="1">{{
                    $t("patch_management.patch_policy.no")
                  }}</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row span="24" style="margin-top:20px;">
              <div v-if="commandForm.isBackup == 0">
                <Row style="margin-bottom: 16px;">
                  <Col span="24" style="font-size: 13px;margin-bottom: 5px;"
                    >{{ $t("patch_management.patch_policy.InAdvance") }}
                    <InputNumber
                      :min="0"
                      v-model="commandForm.backupTime"
                    ></InputNumber>
                    {{ $t("patch_management.patch_policy.MinuteBackup") }}</Col
                  >
                </Row>
              </div>
            </Row>

            <div v-if="commandForm.isBackup == 0">
              <Row span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t(
                  "patch_management.patch_policy.WhetherTheBackupFailsToContinue"
                )
              }}</Row>
              <Row span="24">
                <RadioGroup v-model="commandForm.isBackupFailedContinue">
                  <Radio label="0">{{
                    $t("patch_management.patch_policy.yes")
                  }}</Radio>
                  <Radio label="1">{{
                    $t("patch_management.patch_policy.no")
                  }}</Radio>
                </RadioGroup>
              </Row>
            </div>

            <Row span="24">
              <div v-if="commandForm.isBackup == 0">
                <Row style="margin-top: 16px;">
                  <Col span="24" style="font-size: 13px;margin-bottom: 5px;"
                    >{{ $t("patch_management.patch_policy.BackupRetention") }}
                    <InputNumber
                      :min="0"
                      v-model="commandForm.retentionTime"
                    ></InputNumber>
                    {{ $t("patch_management.patch_policy.Day") }}</Col
                  >
                </Row>
              </div>
            </Row>
          </Card>
        </Col>
      </Row>

      <!-- 目标 -->
      <Row style="margin-bottom: 20px;">
        <Col span="24">
          <Card>
            <Row>
              <Col span="24" class="title">{{
                $t("patch_management.patch_policy.Aims")
              }}</Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.SpecifyTargetMethod")
              }}</Col>
              <Col span="24">
                <RadioGroup
                  v-model="target"
                  @on-change="selectTargetType(target)"
                >
                  <Radio label="0">{{
                    $t("patch_management.patch_policy.SpecifyLabel")
                  }}</Radio>
                  <Radio label="1">{{
                    $t("patch_management.patch_policy.ManuallySelectInstance")
                  }}</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <div v-if="target == '0'">
              <!-- 指定标签 -->
              <FormItem style="margin-left: -99px;">
                <Row>
                  <Col span="7"
                    ><label>{{
                      $t("patch_management.patch_policy.KeyUpToCharacters")
                    }}</label></Col
                  >
                  <Col span="5"
                    ><label>{{
                      $t("patch_management.patch_policy.ValueUpToCharacters")
                    }}</label></Col
                  >
                </Row>
                <FormItem v-for="(tag, index) in commandForm.tags" :key="index">
                  <Row>
                    <Col span="7" style="margin-bottom: 20px;">
                      <FormItem
                        :prop="'tags.' + index + '.key'"
                        :rules="{
                          required: true,
                          message: '键不能为空',
                          trigger: 'blur'
                        }"
                      >
                        <Input
                          type="text"
                          v-model="tag.key"
                          style="width:300px;"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col span="6">
                      <FormItem
                        :prop="'tags.' + index + '.value'"
                        :rules="{
                          required: true,
                          message: '值不能为空',
                          trigger: 'blur'
                        }"
                      >
                        <Input
                          type="text"
                          v-model="tag.value"
                          style="width:300px;"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col span="4" offset="1">
                      <Button @click="handleRemove(index)">{{
                        $t("patch_management.patch_policy.Delete")
                      }}</Button>
                    </Col>
                  </Row>
                </FormItem>
                <Row>
                  <Col span="13">
                    <Button
                      type="dashed"
                      long
                      @click="handleAdd"
                      icon="md-add"
                      style="width:637px;"
                      >{{ $t("patch_management.patch_policy.AddTag") }}</Button
                    >
                  </Col>
                </Row>
              </FormItem>
            </div>

            <!-- 手动选择实例 -->
            <div v-else-if="target == '1'">
              <Row>
                <Col span="24">
                  <div>
                    <Row style="margin-bottom: 16px;">
                      <Col
                        span="24"
                        style="font-size: 13px;margin-bottom: 5px;"
                        >{{
                          $t("patch_management.patch_policy.TargetInstance")
                        }}</Col
                      >
                      <Col span="24">
                        <Input
                          type="text"
                          v-model="instanceId"
                          style="width:40%;margin-bottom: 10px;"
                          :placeholder="
                            $t(
                              'patch_management.patch_policy.QuerybyInstanceID'
                            )
                          "
                          @on-enter="searchInstanceId"
                        ></Input>
                        <v-table
                          :height="459"
                          column-width-drag
                          is-horizontal-resize
                          style="width:100%;font-size: 12px;"
                          :columns="columns"
                          :table-data="tableTargetInstanceDate"
                          row-hover-color="#edf7ff"
                          :is-loading="modal_loadings"
                          title-bg-color="#f8f8f9"
                          :select-group-change="getSelectInstance"
                          :select-all="getSelectInstance"
                        >
                        </v-table>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>

      <!-- 其他参数 -->
      <Row style="margin-bottom: 20px;">
        <Col span="24">
          <Card>
            <Row>
              <Col span="24" class="title">{{
                $t("patch_management.patch_policy.OtherParameters")
              }}</Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.Comment")
              }}</Col>
              <Col span="24">
                <Input
                  v-model="commandForm.description"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder=""
                  style="width:70%;"
                ></Input>
              </Col>
            </Row>
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.TimeoutSeconds")
              }}</Col>
              <Col span="24">
                <Input
                  type="text"
                  v-model="commandForm.executionTimeOut"
                  style="width:70%;"
                ></Input>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <!-- 输出选项 -->
      <Row style="margin-bottom: 20px;">
        <Col span="24">
          <Card>
            <Row>
              <Col span="24" class="title">{{
                $t("patch_management.patch_policy.OutputOptions")
              }}</Col>
            </Row>
            <!-- 启用S​​3 存储桶写入 -->
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t("patch_management.patch_policy.Tip")
              }}</Col>
              <Col span="24">
                <CheckboxGroup
                  v-model="option"
                  @on-change="changeOutputOptions(option)"
                >
                  <Checkbox label="0">{{
                    $t("patch_management.patch_policy.EnableBucketWriting")
                  }}</Checkbox>
                </CheckboxGroup>
              </Col>
              <Col span="24" style="margin-top:20px;">
                <div v-show="isS3">
                  <Row style="margin-bottom: 16px;">
                    <Col
                      span="24"
                      style="font-size: 13px;margin-bottom: 5px;"
                      >{{
                        $t("patch_management.patch_policy.S3BucketName")
                      }}</Col
                    >
                    <Col span="24">
                      <Input
                        type="text"
                        v-model="commandForm.bucketName"
                        style="width:70%;"
                      ></Input>
                    </Col>
                  </Row>
                  <Row style="margin-bottom: 16px;">
                    <Col
                      span="24"
                      style="font-size: 13px;margin-bottom: 5px;"
                      >{{
                        $t("patch_management.patch_policy.S3KeyPrefixOptional")
                      }}</Col
                    >
                    <Col span="24">
                      <Input
                        type="text"
                        v-model="commandForm.keyPrefix"
                        style="width:70%;"
                      ></Input>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <!-- CloudWatch 输出 -->
            <Row style="margin-bottom: 16px;">
              <Col span="24" style="font-size: 13px;margin-bottom: 5px;">{{
                $t(
                  "patch_management.patch_policy.WriteCommandOutputToAmazonCloudWatchLog"
                )
              }}</Col>
              <Col span="24">
                <CheckboxGroup
                  v-model="cloudWatch"
                  @on-change="cloudWatchClick(cloudWatch)"
                >
                  <Checkbox label="0">{{
                    $t("patch_management.patch_policy.CloudWatchOutput")
                  }}</Checkbox>
                </CheckboxGroup>
              </Col>
              <Col span="24" style="margin-top:20px;">
                <div v-show="isCloudWatch">
                  <Row style="margin-bottom: 16px;">
                    <Col
                      span="24"
                      style="font-size: 13px;margin-bottom: 5px;"
                      >{{
                        $t("patch_management.patch_policy.LogGroupNameRequired")
                      }}</Col
                    >
                    <Col span="24">
                      <Input
                        type="text"
                        v-model="commandForm.logGroupName"
                        style="width:70%;"
                      ></Input>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <FormItem style="float: right;">
        <Button
          type="default"
          style="margin-right: 7px;"
          @click="cancel('commandForm')"
          >{{ $t("alarms.common.cancel") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['patchManagement:addOrUpdateRunCommands:save']"
          @click="handleSubmit('commandForm')"
          :loading="loading"
          >{{ $t("patch_management.patch_policy.save") }}</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableRunCommandsVue = {};
export default {
  name: "addOrUpdateRunCommands",
  data() {
    return {
      modal_loadings: false,
      patchPolicyId: "",
      accountId: "",
      region: "",
      commandForm: {
        operation: "",
        snapshotId: "",
        installOverrideList: "",
        description: "",
        bucketName: "",
        keyPrefix: "",
        logGroupName: "",
        isBackup: "0",
        name: "",
        backupTime: 180,
        retentionTime: 1,
        isOutPutS3: "",
        isOutPutCloudWatch: "",
        isBackupFailedContinue: "0",
        executionTimeOut: "600",
        tags: [
          {
            key: "",
            value: ""
          }
        ]
      },
      instanceId: "",
      state: [
        "pending",
        "running",
        "stopping",
        "stopped",
        "shutting down",
        "terminated"
      ],
      selection: [],
      option: [],
      cloudWatch: [],
      loading: false,
      target: "0",
      isS3: false,
      isCloudWatch: false,
      tableTargetInstanceDate: [],
      selectInstanceList: [],
      operationList: [
        {
          id: 0,
          name: "Scan"
        },
        {
          id: 1,
          name: "Install"
        }
      ],
      columns: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection"
        },
        {
          field: "name",
          title: this.$t("patch_management.patch_policy.name"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "instanceId",
          title: this.$t("patch_management.patch_policy.InstanceID"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "agentVersion",
          title: this.$t("patch_management.patch_policy.ProxyVersion"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "state",
          title: this.$t("patch_management.patch_policy.status"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "availabilityZone",
          title: this.$t("patch_management.patch_policy.AvailableArea"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "platform",
          title: this.$t("patch_management.patch_policy.platform"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        }
      ],
      instanceList: []
    };
  },
  beforeCreate: function() {
    tableRunCommandsVue = this;
  },
  mounted() {
    tableRunCommandsVue.init();
    tableRunCommandsVue.select();
  },
  methods: {
    // 初始化数据
    init: function() {
      this.patchPolicyId = this.$route.query.patchPolicyId;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
    },
    // 判断是新增还是编辑
    select: function() {
      this.$api.patchCommandProperty
        .select("patchPolicyId", this.patchPolicyId)
        .then(res => {
          if (res.data.id && res.data.id > 0) {
            // id
            this.commandForm.id = res.data.id;
            // region
            this.region = res.data.region;
            // 操作
            this.commandForm.operation = res.data.operation;
            // 快照Id
            this.commandForm.snapshotId = res.data.snapshotId;
            // 安装覆盖列表
            this.commandForm.installOverrideList = res.data.installOverrideList;
            // 注释
            this.commandForm.description = res.data.description;
            // 超时(秒)
            this.commandForm.executionTimeOut = res.data.executionTimeOut;
            // 是否备份
            this.commandForm.isBackup = String(res.data.isBackup);
            if (this.commandForm.isBackup == "0") {
              // 提前备份时间
              this.commandForm.backupTime = res.data.backupTime;
              // 备份失败是否继续
              this.commandForm.isBackupFailedContinue =
                res.data.isBackupFailedContinue == true ? "0" : "1";
            }
            // 指定目标方式
            this.target = String(res.data.targetType);
            this.instanceList = res.data.instanceDTOS;
            if (this.target == "0") {
              this.commandForm.tags = res.data.tags;
            } else if (this.target == "1") {
              // 目标实例
              /******************************************************/
              this.instanceList = res.data.instanceDTOS;
              this.modal_loadings = true;
              //查询Instance列表
              this.$api.instance
                .queryPatchInstanceByInstanceId({
                  accountId: this.accountId,
                  instanceId: this.instanceId,
                  region: this.region
                })
                .then(res => {
                  this.tableTargetInstanceDate = res.data;
                  tableRunCommandsVue.showInstanceTable();
                  this.modal_loadings = false;
                  for (
                    var i = 0;
                    i < this.tableTargetInstanceDate.length;
                    i++
                  ) {
                    for (var j = 0; j < this.instanceList.length; j++) {
                      if (
                        this.tableTargetInstanceDate[i].instanceId ==
                        this.instanceList[j].instanceId
                      ) {
                        this.tableTargetInstanceDate[i]._checked = true;
                      }
                    }
                  }
                });

              this.selectInstanceList = res.data.instanceDTOS;
            }

            // 写入S3 存储桶
            if (
              res.data.isOutPutS3 != undefined &&
              res.data.isOutPutS3 != null
            ) {
              if (res.data.isOutPutS3 == 0) {
                // 显示
                this.option = ["0"];
                this.isS3 = true;
                // 存储桶名称
                this.commandForm.bucketName = res.data.bucketName;
                // S3密钥前缀
                this.commandForm.keyPrefix = res.data.keyPrefix;
              } else {
                this.option = [];
                this.isS3 = false;
                this.commandForm.bucketName = "";
                this.commandForm.keyPrefix = "";
              }
            }

            // 写入CloudWatch
            if (
              res.data.isOutPutCloudWatch != undefined &&
              res.data.isOutPutCloudWatch != null
            ) {
              if (res.data.isOutPutCloudWatch == 0) {
                // 显示
                this.cloudWatch = ["0"];
                this.isCloudWatch = true;
                // 日志组名称
                this.commandForm.logGroupName = res.data.logGroupName;
              } else {
                this.cloudWatch = [];
                this.isCloudWatch = false;
                // 日志组名称
                this.commandForm.logGroupName = "";
              }
            }
          }
        });
    },
    /**********************查询实例列表************************************/
    //显示表格数据
    showInstanceTable: function() {
      for (var i = 0; i < this.tableTargetInstanceDate.length; i++) {
        // 状态
        if (this.tableTargetInstanceDate[i].state == 0) {
          this.tableTargetInstanceDate[i].state = "pending";
        } else if (this.tableTargetInstanceDate[i].state == 1) {
          this.tableTargetInstanceDate[i].state = "running";
        } else if (this.tableTargetInstanceDate[i].state == 2) {
          this.tableTargetInstanceDate[i].state = "stopping";
        } else if (this.tableTargetInstanceDate[i].state == 3) {
          this.tableTargetInstanceDate[i].state = "stopped";
        } else if (this.tableTargetInstanceDate[i].state == 4) {
          this.tableTargetInstanceDate[i].state = "shutting down";
        } else if (this.tableTargetInstanceDate[i].state == 5) {
          this.tableTargetInstanceDate[i].state = "terminated";
        }
      }
    },
    // 状态
    getState: function(stateStr) {
      for (var i = 0; i < this.state.length; i++) {
        if (stateStr == this.state[i]) {
          return i;
        }
      }
      return -1;
    },
    // 查询实例
    queryPatchInstanceByInstanceId: function() {
      this.$api.instance
        .queryPatchInstanceByInstanceId({
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region
        })
        .then(res => {
          this.tableTargetInstanceDate = res.data;
          tableRunCommandsVue.showInstanceTable();
        });
    },
    // 按下回车键查询实例ID
    searchInstanceId: function() {
      tableRunCommandsVue.queryPatchInstanceByInstanceId();
    },
    // 单选
    getSelectInstance(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.selectInstanceList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var state = tableRunCommandsVue.getState(this.selection[i].state);
        var InstanceDTO = new Object();
        InstanceDTO.instanceId = this.selection[i].instanceId;
        InstanceDTO.name = this.selection[i].name;
        InstanceDTO.agentVersion = this.selection[i].agentVersion;
        InstanceDTO.state = state;
        InstanceDTO.availabilityZone = this.selection[i].availabilityZone;
        InstanceDTO.platform = this.selection[i].platform;
        this.selectInstanceList.push(InstanceDTO);
      }
    },
    /**********************目标切换按钮************************************/
    //目标
    selectTargetType: function() {
      if (this.target == "1") {
        tableRunCommandsVue.queryPatchInstanceByInstanceId();
      }
    },
    /**********************指定标签************************************/
    // 添加标签
    handleAdd() {
      this.commandForm.tags.push({
        value: "",
        key: ""
      });
    },
    // 删除标签
    handleRemove(index) {
      if (this.commandForm.tags.length === 1) {
        this.$Message.warning("至少需要一个子维度");
        return;
      }
      this.commandForm.tags.splice(index, 1);
    },
    /**********************输出选项切换按钮************************************/
    // 输出选项
    changeOutputOptions: function() {
      if (this.option == "0") {
        this.isS3 = true;
      } else {
        this.isS3 = false;
      }
    },
    cloudWatchClick: function() {
      if (this.cloudWatch == "0") {
        this.isCloudWatch = true;
      } else {
        this.isCloudWatch = false;
      }
    },
    /**************************创建或者编辑****************************************/
    createOrUpdate: function(name) {
      var patchCommandPropertyDTO = {
        accountId: this.accountId,
        patchPolicyId: this.patchPolicyId,
        region: this.region,
        operation: parseInt(this.commandForm.operation),
        snapshotId: this.commandForm.snapshotId,
        installOverrideList: this.commandForm.installOverrideList,
        isBackup: parseInt(this.commandForm.isBackup),
        targetType: parseInt(this.target),
        description: this.commandForm.description,
        bucketName: this.commandForm.bucketName,
        keyPrefix: this.commandForm.keyPrefix,
        logGroupName: this.commandForm.logGroupName,
        retentionTime: this.commandForm.retentionTime,
        executionTimeOut: parseInt(this.commandForm.executionTimeOut)
      };
      if (this.commandForm.isBackup == "0") {
        patchCommandPropertyDTO.backupTime = parseInt(
          this.commandForm.backupTime
        );
        patchCommandPropertyDTO.isBackupFailedContinue =
          this.commandForm.isBackupFailedContinue == 0 ? true : false;
      }

      // 目标
      if (this.target == "0") {
        patchCommandPropertyDTO.tags = this.commandForm.tags;
      } else if (this.target == "1") {
        patchCommandPropertyDTO.instanceDTOS = this.selectInstanceList;
      }

      let option = this.option[0];
      if (option != undefined && option == "0") {
        patchCommandPropertyDTO.isOutPutS3 = parseInt(option);
        patchCommandPropertyDTO.bucketName = this.commandForm.bucketName;
        patchCommandPropertyDTO.keyPrefix = this.commandForm.keyPrefix;
      } else {
        patchCommandPropertyDTO.isOutPutS3 = "";
        patchCommandPropertyDTO.bucketName = "";
        patchCommandPropertyDTO.keyPrefix = "";
      }

      let cloudWatch = this.cloudWatch[0];
      if (cloudWatch != undefined && cloudWatch == "0") {
        patchCommandPropertyDTO.isOutPutCloudWatch = parseInt(cloudWatch);
        patchCommandPropertyDTO.logGroupName = this.commandForm.logGroupName;
      } else {
        patchCommandPropertyDTO.isOutPutCloudWatch = "";
        patchCommandPropertyDTO.logGroupName = "";
      }

      if (this.commandForm.id > 0) {
        patchCommandPropertyDTO.id = this.commandForm.id;
      }
      this.loading = true;
      this.$api.patchCommandProperty
        .createOrUpdatePatchCommandProperty(patchCommandPropertyDTO)
        .then(res => {
          this.data = res.data;
          setTimeout(() => {
            this.loading = false;
            this.$emit("on-ok", this.form);
            this.$Message.success("保存成功");
            history.go(-1);
          }, 1000);
        });
    },

    /**********************添加或者编辑**************************************/
    handleSubmit: function(name) {
      // 目标
      if (this.target == "0") {
        this.$refs[name].validate(valid => {
          if (valid) {
            // todo  验证通过
            this.createOrUpdate();
          } else {
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true;
            }, 0);
            if (this.commandForm.id > 0) {
              this.$Message.error("编辑失败");
            } else {
              this.$Message.error("添加失败");
            }
          }
        });
      } else if (this.target == "1") {
        if (this.selectInstanceList.length === 0) {
          this.$Message.warning("至少需要一个目标实例");
          return;
        }
        this.createOrUpdate();
      }
    },
    // 取消
    cancel: function(name) {
      history.go(-1);
    }
  }
};
</script>

<style scoped>
.addOrUpdateRunCommands-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.title {
  font-size: 14px;
  font-weight: 600;
  float: left;
  color: #000;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/AddOrUpdateRunCommands.vue